import React, { useState } from 'react';
import { SxProps, Theme } from '@mui/material';
import { Card, CardContent, Button, Box } from '@mui/material';
import { CcfLeftArrowIcon } from '../../icons/ccf-left-arrow-icon/ccf-left-arrow-icon';
import { CcfRightArrowIcon } from '../../icons/ccf-right-arrow-icon/ccf-right-arrow-icon';
import { useTheme } from '@mui/material';

export interface CcfCarouselProps {
  children?: React.ReactElement[];
  sx?: {
    activeIndicator: SxProps<Theme>;
    card: SxProps<Theme>;
    cardContent: SxProps<Theme>;
    indicator: SxProps<Theme>;
    indicators: SxProps<Theme>;
    carouselDots: SxProps<Theme>;
    responseText: SxProps<Theme>;
    mainCard: SxProps<Theme>;
    iconsHover: SxProps<Theme>;
  };
  index? : number;
}

/**
 * Functional component is a wrapper for material UI card component
 * @returns material UI carousel element
 * @example <CcfCarousel/>
 */
export function CcfCarousel({ children = [], sx, index}: CcfCarouselProps) {
  const [cardIndex, setCardIndex] = useState(index ?? 0);
  const theme = useTheme();

  const cardContentStyle = {
    ...(sx?.cardContent || {}),
    '&.MuiCardContent-root': {
      padding: children && children.length === 1 ? '0.625rem': 0,
    },
  };

  /**
    * method to handle click of left arrow icon
    * @example 
    * ```
    * handleLeftArrowClick()
    * ```
  */
  const handleLeftArrowClick = () => {
    setCardIndex((prevCard) => (prevCard - 1 + children.length) % children.length);
  };
  
  /**
    * method to handle click of right arrow icon 
    * @example 
    * ```
    * handleRightArrowClick()
    * ```
   */
  const handleRightArrowClick = () => {
    setCardIndex((prevCard) => (prevCard + 1) % children.length);
  };

  return (
    <Box>
      <Box sx={sx?.mainCard}>
        {children?.length > 1 && <CcfLeftArrowIcon onClick={() => handleLeftArrowClick()} data-testid="left-arrow-icon" sx={sx?.iconsHover} fill={theme?.palette?.text?.dark}/>}
        <Card sx={sx?.card}>
          {children?.length && (
            <CardContent sx={cardContentStyle} data-testid="cardcontent">
              <div
                style={{
                  display: 'block',
                }}
              >
                {children[cardIndex]}
              </div>
            </CardContent>
          )}
        </Card>
        {children?.length > 1 && <CcfRightArrowIcon onClick={() => handleRightArrowClick()} data-testid="right-arrow-icon" sx={sx?.iconsHover} fill={theme?.palette?.text?.dark}/>}
      </Box>
      {children.length > 1 && (
        <Box sx={sx?.carouselDots}>
          {children.map((_, index) => (
            <Button
              sx={index === cardIndex ? { ...sx?.activeIndicator } : { ...sx?.indicator }}
            ></Button>
          ))}
        </Box>
      )}
    </Box>
  );
}